export type CampaignListMobilePanel = "sort" | "columns";

export type CampaignListMobileToolsState = {
  overflowOpen: boolean;
  panel: CampaignListMobilePanel | null;
  pendingPanel: CampaignListMobilePanel | null;
};

export const CAMPAIGN_LIST_MOBILE_TOOLS_CLOSED: CampaignListMobileToolsState = {
  overflowOpen: false,
  panel: null,
  pendingPanel: null,
};

/** Open the panel after DropdownMenu's pointer/focus dismiss cycle finishes. */
export const CAMPAIGN_LIST_MOBILE_PANEL_OPEN_MS = 0;

export function campaignListMobileOpenOverflow(
  _state: CampaignListMobileToolsState,
): CampaignListMobileToolsState {
  return {
    overflowOpen: true,
    panel: null,
    pendingPanel: null,
  };
}

export function campaignListMobileSelectOverflowItem(
  state: CampaignListMobileToolsState,
  panel: CampaignListMobilePanel,
): CampaignListMobileToolsState {
  return {
    ...state,
    pendingPanel: panel,
  };
}

export function campaignListMobileOverflowClosed(state: CampaignListMobileToolsState): {
  next: CampaignListMobileToolsState;
  panelToOpen: CampaignListMobilePanel | null;
} {
  return {
    next: {
      ...state,
      overflowOpen: false,
    },
    panelToOpen: state.pendingPanel,
  };
}

export function campaignListMobileSetPanel(
  state: CampaignListMobileToolsState,
  panel: CampaignListMobilePanel | null,
): CampaignListMobileToolsState {
  return {
    overflowOpen: false,
    panel,
    pendingPanel: null,
  };
}
